import Carousel from 'antd-mobile/lib/carousel';
export default Carousel;



// WEBPACK FOOTER //
// ./components/carousel/index.tsx